import type { WebPermission } from '@dawn/feature-config';

import { useSessionStore } from '@/stores/session';

/** Permission checks over the session user (TDEV-1213); no network, the server checks every request itself. */
export function usePermissions(): { can: (slug: WebPermission) => boolean } {
  const permissions = useSessionStore((s) => s.user?.permissions);
  return { can: (slug) => permissions?.includes(slug) ?? false };
}
